import { Base } from '../DataModels/Base';
import { MealType } from '../DataModels/Meal';
import {ModalController, PopoverController} from '@ionic/angular';

export function toLocalDate(date: string): Date {
    if (typeof(date) !== 'string') { return new Date(0); }
    const temp = date.slice(0, 10);
    const parts = temp.split('-');
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
}

export function toJSONLocal(date: Date): string {
    const local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
}

export function toJSONLocalArray(date: Date[]): string[] {
    const ret: string[] = [];
    date.forEach(d => {
        ret.push(toJSONLocal(d));
    });
    return ret;
}

export function todayDateOnly(): Date {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
}

export function yesterdayDateOnly(): Date {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

export function beforeXDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
}

export function sameDay(d1: Date, d2: Date) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
}

export function stringToValidDate(input: string): Date {
    const date = new Date(input);
    return !isNaN(date.getTime()) ? date : new Date(0);
}

export function toInterfaceArray<Type1 extends Base, Type2>(arg: Type1[]): Type2[] {
    if (!arg) { return []; }
    const ret: Type2[] = [];
    arg.forEach(element => {
        ret.push(element.toInterface());
    });
    return ret;
}

// Match the meal types to displayable strings
export function mealTypeToString(typicalMeal: MealType, short: boolean = false): string {
    switch (typicalMeal){
      case MealType.Breakfast: {
        return short ? 'Früh' : 'Frühstück';
      }
      case MealType.Lunch: {
        return short ? 'Mittag' : 'Mittagessen';
      }
      case MealType.Dinner: {
        return short ? 'Abend' : 'Abendessen';
      }
      case MealType.Snack: {
        return 'Snack';
      }
    }
  }

export function vwToPx(vw: number): number {
    return window.innerWidth * vw / 100;
}

export function percentToPx(percent: number, el: HTMLElement, takeWidth: boolean = false): number {
    if (!el) { return 0; }
    const rect = el.getBoundingClientRect();
    const rel = takeWidth ? rect.width : rect.height;
    return rel * percent / 100;
}

export function removeUnit(input: string, unitLength: number = 2): number {
    return +input.substring(0, input.length - unitLength);
}

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function deepCloneObject(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
}

export function roundDecimals(num: number, decimals: number): number {
    const multiplier = Math.pow(10, decimals);
    return Math.round((num + Number.EPSILON) * multiplier) / multiplier;
}

export function closeAllModals(modalController: ModalController): void {
  modalController.getTop().then(res => {
    if (res) {
      modalController.dismiss().then(() => closeAllModals(modalController));
    }
  });
}

export function closeAllPopovers(popoverController: PopoverController): void {
  popoverController.getTop().then(res => {
    if (res) {
      popoverController.dismiss().then(() => closeAllPopovers(popoverController));
    }
  });
}
